import React, { useState, useContext } from "react";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { place_order } from "../store/reducers/orderReducer";
import api from "../api/api";
import { LanguageContext } from "../context/LanguageContext";

const Shipping = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useContext(LanguageContext);
  const { userInfo } = useSelector((state) => state.auth);
  const {
    state: { products, price, shipping_fee, items },
  } = useLocation();
  const [res, setRes] = useState(false);
  const [state, setState] = useState({
    name: "",
    address: "",
    phone: "",
    post: "",
    province: "",
    city: "",
    area: "",
    email: userInfo?.email || "",
  });
  const [savedAddresses, setSavedAddresses] = useState([]);
  const [selectedAddressIndex, setSelectedAddressIndex] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const inputHandle = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };
  const save = (e) => {
    e.preventDefault();
    const { name, address, phone, post, province, city, area } = state;
    if (name && address && phone && post && province && city && area) {
      // if user logged in, try to save to server (respect max 3)
      if (userInfo && userInfo.id) {
        api
          .post("/home/customer/addresses", state)
          .then((res) => {
            if (res.data?.addresses) {
              setSavedAddresses(res.data.addresses);
              setSelectedAddressIndex(res.data.addresses.length - 1);
            }
            setRes(true);
          })
          .catch((err) => {
            // if server rejects (e.g., max 3) just setRes and show message
            console.error(err);
            setRes(true);
          });
      } else {
        setRes(true);
      }
    }
  };
  const placeOrder = () => {
    const shippingInfo =
      selectedAddressIndex !== null
        ? {
            ...savedAddresses[selectedAddressIndex],
            email:
              userInfo?.email ||
              savedAddresses[selectedAddressIndex]?.email ||
              "",
          }
        : { ...state, email: userInfo?.email || state.email || "" };

    dispatch(
      place_order({
        price,
        products,
        shipping_fee,
        shippingInfo,
        userId: userInfo?.id,
        navigate,
        items,
      }),
    );
  };

  // load saved addresses on mount
  React.useEffect(() => {
    if (userInfo && userInfo.id) {
      api
        .get("/home/customer/addresses")
        .then((res) => {
          setSavedAddresses(res.data.addresses || []);
        })
        .catch((err) => console.error(err));
    }
  }, [userInfo]);
  return (
    <div>
      <Headers />
      <div className="bg-[#eeeeee] w-full">
        <div className="max-w-[1440px] mx-auto px-16 sm:px-5 md-lg:px-12 md:px-10 pt-6">
          <section
            style={{ backgroundImage: 'url("/images/banner/order.jpg")' }}
            className="h-[220px]  bg-cover bg-no-repeat relative bg-left"
          >
            <div className="absolute left-0 top-0 w-full h-full bg-[#2422228a]">
              <div className="w-full h-full mx-auto">
                <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white">
                  <h2 className="text-3xl font-bold">{t("hagereShop")}</h2>
                  <div className="flex justify-center items-center gap-2 text-2xl w-full">
                    <Link to="/">{t("home")}</Link>
                    <span className="pt-2">
                      <MdOutlineKeyboardArrowRight />
                    </span>
                    <span>{t("placeOrder")}</span>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <section className="bg-[#eeeeee]">
        <div className="max-w-[1440px] mx-auto px-16 sm:px-5 md-lg:px-12 md:px-10 py-16">
          <div className="w-full flex flex-wrap">
            <div className="w-[67%] md-lg:w-full">
              <div className="flex flex-col gap-3">
                <div className="bg-white p-6 shadow-sm rounded-md">
                  {/* Saved addresses */}
                  {savedAddresses && savedAddresses.length > 0 && (
                    <div className="mb-4">
                      <h3 className="text-sm font-medium">
                        {t("savedAddresses")}
                      </h3>
                      <div className="flex flex-col gap-2 mt-2">
                        {savedAddresses.map((a, idx) => (
                          <div
                            key={idx}
                            className={`p-2 border rounded ${
                              selectedAddressIndex === idx
                                ? "border-indigo-500"
                                : ""
                            }`}
                          >
                            <div className="flex justify-between items-center">
                              <div>
                                <div className="font-semibold">{a.name}</div>
                                <div className="text-sm text-slate-600">
                                  {a.address} {a.province} {a.city} {a.area}
                                </div>
                                <div className="text-sm text-slate-600">
                                  {a.phone}
                                </div>
                              </div>
                              <div className="flex flex-col gap-1">
                                <button
                                  onClick={() => {
                                    setSelectedAddressIndex(idx);
                                    setRes(true);
                                  }}
                                  className="text-indigo-600 text-sm"
                                >
                                  {t("useLabel")}
                                </button>
                                <button
                                  onClick={() => {
                                    setDeleteIndex(idx);
                                    setShowDeleteModal(true);
                                  }}
                                  className="text-red-600 text-sm"
                                >
                                  {t("deleteLabel")}
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Delete Confirmation Modal */}
                  {showDeleteModal && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                      <div className="bg-white rounded-lg shadow-lg p-6 w-[90vw] max-w-sm text-center">
                        <h2 className="text-lg font-semibold mb-4 text-gray-800">
                          {t("deleteAddressTitle")}
                        </h2>
                        <p className="mb-6 text-gray-700">
                          {t("deleteAddressConfirm")}
                        </p>
                        <div className="flex justify-center gap-4">
                          <button
                            onClick={() => {
                              if (deleteIndex === null)
                                return setShowDeleteModal(false);
                              api
                                .delete(
                                  `/home/customer/addresses/${deleteIndex}`,
                                )
                                .then((r) => {
                                  setSavedAddresses(r.data.addresses || []);
                                  setShowDeleteModal(false);
                                  setDeleteIndex(null);
                                  // if deleted the selected address, clear selection
                                  if (selectedAddressIndex === deleteIndex) {
                                    setSelectedAddressIndex(null);
                                    setRes(false);
                                  }
                                })
                                .catch((e) => {
                                  console.error(e);
                                  setShowDeleteModal(false);
                                  setDeleteIndex(null);
                                });
                            }}
                            className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded"
                          >
                            {t("delete")}
                          </button>
                          <button
                            onClick={() => {
                              setShowDeleteModal(false);
                              setDeleteIndex(null);
                            }}
                            className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded"
                          >
                            {t("cancel")}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {!res && (
                    <>
                      <h2 className="text-slate-600 font-bold pb-3">
                        {t("shippingInformation")}
                      </h2>
                      <form onSubmit={save}>
                        <div className="flex md:flex-col md:gap-2 w-full gap-5 text-slate-600">
                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <label htmlFor="name">{t("name")}</label>
                            <input
                              onChange={inputHandle}
                              value={state.name}
                              type="text"
                              className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-indigo-500 rounded-md"
                              name="name"
                              placeholder={t("name")}
                              id="name"
                            />
                          </div>
                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <label htmlFor="address">{t("addressLabel")}</label>
                            <input
                              onChange={inputHandle}
                              value={state.address}
                              type="text"
                              className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-indigo-500 rounded-md"
                              name="address"
                              placeholder={t("addressLabel")}
                              id="address"
                            />
                          </div>
                        </div>
                        <div className="flex md:flex-col md:gap-2 w-full gap-5 text-slate-600">
                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <label htmlFor="phone">{t("phoneLabel")}</label>
                            <input
                              onChange={inputHandle}
                              value={state.phone}
                              type="text"
                              className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-indigo-500 rounded-md"
                              name="phone"
                              placeholder={t("phoneLabel")}
                              id="phone"
                            />
                          </div>
                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <label htmlFor="post">{t("postLabel")}</label>
                            <input
                              onChange={inputHandle}
                              value={state.post}
                              type="text"
                              className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-indigo-500 rounded-md"
                              name="post"
                              placeholder={t("postLabel")}
                              id="post"
                            />
                          </div>
                        </div>
                        <div className="flex md:flex-col md:gap-2 w-full gap-5 text-slate-600">
                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <label htmlFor="province">{t("regionLabel")}</label>
                            <input
                              onChange={inputHandle}
                              value={state.province}
                              type="text"
                              className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-indigo-500 rounded-md"
                              name="province"
                              placeholder={t("regionLabel")}
                              id="province"
                            />
                          </div>
                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <label htmlFor="city">{t("cityLabel")}</label>
                            <input
                              onChange={inputHandle}
                              value={state.city}
                              type="text"
                              className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-indigo-500 rounded-md"
                              name="city"
                              placeholder={t("cityLabel")}
                              id="city"
                            />
                          </div>
                        </div>
                        <div className="flex md:flex-col md:gap-2 w-full gap-5 text-slate-600">
                          <div className="flex flex-col gap-1 mb-2 w-full">
                            <label htmlFor="area">{t("zoneLabel")}</label>
                            <input
                              onChange={inputHandle}
                              value={state.area}
                              type="text"
                              className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-indigo-500 rounded-md"
                              name="area"
                              placeholder={t("zoneLabel")}
                              id="province"
                            />
                          </div>
                          <div className="flex flex-col gap-1 mt-3 w-full">
                            <button className="px-3 py-[6px] rounded-sm hover:shadow-indigo-500/20 hover:shadow-lg bg-indigo-500 text-white">
                              {t("save")}
                            </button>
                          </div>
                        </div>
                      </form>
                    </>
                  )}
                  {res && (
                    <div className="flex flex-col gap-1">
                      <h2 className="text-slate-600 font-semibold pb-2">
                        {t("deliverTo")} {state.name}
                      </h2>
                      <p>
                        <span className="bg-blue-200 text-blue-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded">
                          Home
                        </span>
                        <span className="text-slate-600 text-sm">
                          {state.address} {state.province} {state.city}{" "}
                          {state.area}
                        </span>
                        <span
                          onClick={() => setRes(false)}
                          className="text-indigo-500 cursor-pointer"
                        >
                          {t("change")}
                        </span>
                      </p>
                      <p className="text-slate-600 text-sm">
                        {t("emailTo")} ${userInfo?.email || "test@gmail.com"}
                      </p>
                    </div>
                  )}
                </div>
                {products.map((p, i) => (
                  <div key={i} className="flex bg-white p-4 flex-col gap-2">
                    <div className="flex justify-start items-center">
                      <h2 className="text-md text-slate-600">{p.shopName}</h2>
                    </div>
                    {p.products.map((pt, j) => (
                      <div key={i + 99} className="w-full flex flex-wrap">
                        <div className="flex sm:w-full gap-2 w-7/12">
                          <div className="flex gap-2 justify-start items-center">
                            <img
                              className="w-[80px] h-[80px]"
                              src={pt.productInfo.images[0]}
                              alt="product image"
                            />
                            <div className="pr-4 text-slate-600">
                              <h2 className="text-md">{pt.productInfo.name}</h2>
                              <span className="text-sm">
                                Brand : {pt.productInfo.brand}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="flex justify-end w-5/12 sm:w-full sm:mt-3">
                          <div className="pl-4 sm:pl-0">
                            <h2 className="text-lg text-orange-500">
                              {pt.productInfo.price -
                                Math.floor(
                                  (pt.productInfo.price *
                                    pt.productInfo.discount) /
                                    100,
                                )}{" "}
                              birr
                            </h2>
                            <p className="line-through">
                              {pt.productInfo.price} birr
                            </p>
                            <p>-{pt.productInfo.discount}%</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
            <div className="w-[33%] md-lg:w-full">
              <div className="pl-3 md-lg:pl-0">
                <div className="bg-white font-medium p-5 text-slate-600 flex flex-col gap-3">
                  <h2 className="text-xl font-semibold">{t("orderSummary")}</h2>
                  <div className="flex justify-between items-center">
                    <span>
                      {t("itemsTotal")}({price})
                    </span>
                    <span>{price} birr</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span>{t("deliveryFee")}</span>
                    <span>{shipping_fee} birr</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span>{t("totalLabel")}</span>
                    <span>{price + shipping_fee} birr</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span>{t("totalLabel")}</span>
                    <span>{price + shipping_fee} birr</span>
                  </div>
                  <button
                    onClick={placeOrder}
                    disabled={res ? false : true}
                    className={`px-5 py-[6px] rounded-sm hover:shadow-orange-500/20 hover:shadow-lg ${
                      res ? "bg-orange-500" : "bg-orange-300"
                    } text-sm text-white uppercase`}
                  >
                    {t("placeOrder")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Shipping;
